import { IDefaultComponentProps } from '@src/models/props';
import { classnames } from '@src/utils/classnames';
import React, { FC } from 'react';
import styled from './FormItem.module.scss';

export interface IProps extends IDefaultComponentProps {
  /** Ошибка для отображения */
  error?: string;
}

/** Компонент для отображения в статуса загрузки */
export const FormItem: FC<IProps> = ({ children, className, error, ...rest }) => {
  const classes = classnames(className, styled.root);

  return (
    <div className={classes} {...rest}>
      {children}
      <div className={styled.error} data-id={'errorMsg'}>
        {error}
      </div>
    </div>
  );
};
